import styled from "styled-components";
import { theme } from "../../styles/theme";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%; 
  margin: 29px 0 18px 0; 
  gap: 26px;
  align-items: flex-start;
  overflow: hidden;

  @media (max-width: ${theme.breakpoints.sm}) {
    flex-direction: column;
    margin: 29px 0 120px 0;
  }
`;

export const FloatingCard = styled.div`
  position: fixed;
  left: 97px;
  z-index: 5;
  min-width: 60%;

  @media (max-width: ${theme.breakpoints.sm}) {
    position: relative;
    left: 0;
    min-width: 100%;
  }
`;

export const ContentContainer = styled.div`
  max-width: 30%;
  flex: 1;
  overflow-y: auto;
  height: 80vh;

  @media (max-width: ${theme.breakpoints.sm}) {
    max-width: 100%;
  }
`;